"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
var mockUsersData = {
    users: [
        { email: 'aa@aa.aa', uuid: '123' },
        { email: 'bb@bb.bb', uuid: '234' },
        { email: 'cc@cc.cc', uuid: '345' },
        { email: 'dd@dd.dd', uuid: '456' },
    ],
};
exports.default = mockUsersData;
